import { useTransactions } from "api/transactions";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { TransactionForm } from "./TransactionForm";

export function EditTransaction() {
  const { message } = useMessage();
  const { useTransactionData } = useTransactions();
  const { id: transactionID } = useParams<{ id: string }>();
  const { data: transactionData } = useTransactionData(transactionID as string);

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "transactions" }),
      path: links.transactionsList,
    },
  };

  return (
    <>
      <TopHeader
        title={`${message({ id: "editTransaction" })} ${transactionID}`}
        clearLink={links.transactionsList}
        breadcrumbs={breadcrumbs}
      />
      <TransactionForm editMode initialValues={transactionData} />
    </>
  );
}
